export default "__VITE_ASSET__07074e18__"